import { Box, Heading } from "@vinomofo/components";

import { ContentfulPageProps } from "../../templates/content-page";

export const SimplePageHeader = ({
  title,
}: Pick<ContentfulPageProps, "title">): JSX.Element => {
  return (
    <Box width="100%" display="flex" justifyContent="center" marginTop={100}>
      <Heading variant="xl" as="h1">
        {title}
      </Heading>
    </Box>
  );
};
